module.exports = __webpack_public_path__ + "img/top_title.1a99cbb9.png";